export enum CATEGOR_VALUE_TYPE {
    LN = 'LAND',
    V = 'VILLA',
    N = 'NORMAL',
    VL = 'VILLAS',
    PL = 'PLANNED',
    BL = 'BUILDING',
    OFF_PLAN = 'OFF-PLAN-SALE'
}